import * as React from 'react'

import Svg, { Circle, Path } from 'react-native-svg'

const DocumentErrorFilled = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={72}
    viewBox="0 0 72 72"
    fill="none"
    {...props}
  >
    <Path
      fill="#FFFFFF"
      stroke="#D5D9DD"
      strokeWidth={2}
      d="M17 9h28l10 10v42a2 2 0 0 1-2 2H17a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2Z"
    />
    <Path fill="#EFF1F3" stroke="#D5D9DD" strokeWidth={2} d="M45 9v10h10" />
    <Path
      stroke="#AEB6BD"
      strokeLinecap="round"
      strokeWidth={3}
      d="M22 22h14M22 30h24M22 38h24"
    />
    <Circle cx={49} cy={50} r={13} fill="#E5484D" />
    <Path
      stroke="#FFFFFF"
      strokeLinecap="round"
      strokeWidth={3}
      d="M49 43.5v8"
    />
    <Circle cx={49} cy={56.5} r={1.75} fill="#FFFFFF" />
  </Svg>
)
export default DocumentErrorFilled
